import { Shield, Lock, Eye, FileCheck, AlertTriangle, CheckCircle } from "lucide-react";

export const Security = () => {
  const securityFeatures = [
    {
      icon: Lock,
      title: "Encrypted File Platform",
      description: "All documents and communications are protected with bank-level encryption.",
    },
    {
      icon: Eye,
      title: "Seller Identity Verification",
      description: "Multi-step verification process to confirm seller identity before any transaction.",
    },
    {
      icon: FileCheck,
      title: "Wire Fraud Prevention",
      description: "Strict protocols and verification procedures for all wire transfers.",
    },
    {
      icon: AlertTriangle,
      title: "Industry Best Practices",
      description: "Full compliance with ALTA best practices and state-specific regulations.",
    },
  ];

  return (
    <section id="security" className="py-24 lg:py-32 bg-[#0F172A]" data-testid="security-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-3 bg-white/10 text-white px-4 py-2 mb-8">
              <Shield className="w-4 h-4 text-[#B45309]" strokeWidth={1.5} />
              <span className="text-xs font-bold uppercase tracking-widest">Security & Compliance</span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl font-medium text-white tracking-tight mb-6">
              Your Transaction, Protected
            </h2>
            <p className="text-lg text-white/70 leading-relaxed mb-10">
              In an era of increasing wire fraud and cybercrime, we've implemented robust 
              security measures that protect every party in your transaction. Our commitment 
              to security is not just policy, it's practice.
            </p>

            {/* Security Stats */}
            <div className="flex gap-8">
              <div className="text-center" data-testid="security-stat-1">
                <p className="font-serif text-4xl font-medium text-white mb-1">100%</p>
                <p className="text-xs uppercase tracking-widest text-white/50">Wire Verification</p>
              </div>
              <div className="text-center" data-testid="security-stat-2">
                <p className="font-serif text-4xl font-medium text-white mb-1">256-bit</p>
                <p className="text-xs uppercase tracking-widest text-white/50">Encryption</p>
              </div>
              <div className="text-center" data-testid="security-stat-3">
                <p className="font-serif text-4xl font-medium text-white mb-1">ALTA</p>
                <p className="text-xs uppercase tracking-widest text-white/50">Compliant</p>
              </div>
            </div>
          </div>

          {/* Right - Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {securityFeatures.map((feature, index) => (
              <div
                key={index}
                className="p-6 bg-white/5 border border-white/10 hover:bg-white/10 btn-transition"
                data-testid={`security-feature-${index}`}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#B45309]/20 mb-4">
                  <feature.icon className="w-5 h-5 text-[#B45309]" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-lg font-medium text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
